export class ShowScreenTooSmall {
    static readonly type = '[User] Show screen too small';
}

export class HideScreenTooSmall {
    static readonly type = '[User] Hide screen too small';
}
